import CloseNotification from '../closeNotification';
import {colors} from 'ui/config';

export default {
  hideProgressBar: true,
  pauseOnHover: true,
  style: {borderRadius: 10, background: colors.beige, padding: 13, paddingRight: 21},
  closeButton: CloseNotification,
  autoClose: false,
  closeOnClick: false,
};
